var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fill-height":""}},[_c('v-row',{attrs:{"align":"center","justify":"center","fill-height":""}},[_c('v-col',{attrs:{"cols":"12","xl":"10"}},[_c('CustomersTable')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }